import { render } from "./AiChatDialog.vue?vue&type=template&id=7bbd40cd&scoped=true"
import script from "./AiChatDialog.vue?vue&type=script&lang=js"
export * from "./AiChatDialog.vue?vue&type=script&lang=js"

import "./AiChatDialog.vue?vue&type=style&index=0&id=7bbd40cd&lang=scss&scoped=true"
import "./AiChatDialog.vue?vue&type=style&index=1&id=7bbd40cd&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bbd40cd"],['__file',"src/views/h5/common/home/components/AiChatDialog.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7bbd40cd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7bbd40cd', __exports__)) {
    api.reload('7bbd40cd', __exports__)
  }
  
  module.hot.accept("./AiChatDialog.vue?vue&type=template&id=7bbd40cd&scoped=true", () => {
    api.rerender('7bbd40cd', render)
  })

}


export default __exports__